import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledScore, StyledScoreOutOf, StyledScoreRating, StyledReviewsLogo, } from './reviews.styles';
/**
 * A component that displays a given Reviews score.
 */
export const Reviews = ({ score, translations }) => {
    const maxScore = 5;
    if (!score || score > maxScore) {
        return null;
    }
    const ariaLabel = `${translations.rating} - ${score} ${translations.outOf} ${maxScore}`;
    const outOf = `${translations.outOf} ${maxScore}`;
    return (_jsxs(StyledScore, { "aria-label": ariaLabel, title: ariaLabel, children: [_jsx(StyledReviewsLogo, {}), _jsx(StyledScoreRating, { children: score }), _jsx(StyledScoreOutOf, { children: outOf })] }));
};
//# sourceMappingURL=reviews.js.map